import styled from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'

const ShopSimilarButton = styled(Button)`
  display: flex;
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 36px;
  border: 1px solid ${props => props.theme.color.alias.cta.secondary.default.border};
  background-color: ${props => props.theme.color.palette.white};
  padding: 8px;

  span {
    font-size: 14px;
    font-weight: 400;
  }

  circle {
    stroke: ${props => props.theme.color.alias.cta.secondary.default.border};
  }

  &:hover,
  &:focus,
  &:active {
    background-color: ${props => props.theme.color.monochrome.lighter};
  }
`

export { ShopSimilarButton }
